module.exports = __webpack_public_path__ + "img/SAFo_KeyTakeAways_SocialEngineer.6ae94499.svg";